export enum PageType {
  EVENTS = 'events',
  COLLECTION = 'collection',
  HOME = 'home'
}
